module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/building-7315c72cef2b7ef0402496e2bebabc02.svg";